import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import {
  CreateUtilityRateRequest,
  UpdateUtilityRateRequest,
  UtilityRate,
} from 'brain-data/model/utility-rate.model';

export const loadUtilityRates = createAction('[UtilityRates] load');
export const loadUtilityRatesSuccess = createAction(
  '[UtilityRates] load success',
  props<{ rates: UtilityRate[] }>(),
);
export const loadUtilityRatesError = createAction(
  '[UtilityRates] load error',
  props<{ error: HttpErrorResponse }>(),
);

export const createUtilityRate = createAction(
  '[UtilityRates] create',
  props<{ payload: CreateUtilityRateRequest }>(),
);
export const createUtilityRateSuccess = createAction(
  '[UtilityRates] create success',
  props<{ rate: UtilityRate }>(),
);
export const createUtilityRateError = createAction(
  '[UtilityRates] create error',
  props<{ error: HttpErrorResponse }>(),
);

export const updateUtilityRate = createAction(
  '[UtilityRates] update',
  props<{ id: number; payload: UpdateUtilityRateRequest }>(),
);
export const updateUtilityRateSuccess = createAction(
  '[UtilityRates] update success',
  props<{ rate: UtilityRate }>(),
);
export const updateUtilityRateError = createAction(
  '[UtilityRates] update error',
  props<{ error: HttpErrorResponse }>(),
);

export const deleteUtilityRate = createAction(
  '[UtilityRates] delete',
  props<{ id: number }>(),
);
export const deleteUtilityRateSuccess = createAction(
  '[UtilityRates] delete success',
  props<{ id: number }>(),
);
export const deleteUtilityRateError = createAction(
  '[UtilityRates] delete error',
  props<{ error: HttpErrorResponse }>(),
);
